import { Link, useLocation } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

const TABS = [
  ["Inspection readiness", "/accreditation"],
  ["Checklist manager", "/accreditation/checklist"],
  ["Proficiency testing", "/accreditation/pt"],
  ["Nonconformance & CAPA", "/accreditation/nonconformance"],
  ["Specimen rejections", "/accreditation/rejections"],
  ["Frozen sections & IOC", "/accreditation/frozen"],
  ["Report distribution", "/accreditation/distribution"],
  ["Consults & peer review", "/accreditation/consults"],
  ["Retention & disposal", "/accreditation/retention"],
];

export const ModuleNav = ({ title, blurb, actions }) => {
  const { pathname } = useLocation();
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-end gap-4">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#134e4a]">CAPTraX</p>
          <h1 className="mt-1 flex items-center gap-2 font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            <ShieldCheck size={26} className="text-[#134e4a]" /> {title}
          </h1>
          {blurb && <p className="mt-1 max-w-3xl text-sm text-slate-600">{blurb}</p>}
        </div>
        {actions && <div className="ml-auto flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
      <nav className="flex flex-wrap gap-x-1 gap-y-1 border-b border-slate-200" data-testid="accreditation-nav">
        {TABS.map(([label, to]) => {
          const active = pathname === to;
          return (
            <Link key={to} to={to} data-testid={`accred-tab-${to.split("/").pop()}`}
                  className={`-mb-px border-b-2 px-3 py-2 text-sm font-semibold transition-colors ${
                    active ? "border-[#134e4a] text-[#134e4a]" : "border-transparent text-slate-500 hover:text-[#134e4a]"}`}>
              {label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};
